import { render } from "./cluster.vue?vue&type=template&id=b97a24d2"
import script from "./cluster.vue?vue&type=script&lang=js"
export * from "./cluster.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"node_modules/@fawmi/vue-google-maps/src/components/cluster.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b97a24d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b97a24d2', __exports__)) {
    api.reload('b97a24d2', __exports__)
  }
  
  module.hot.accept("./cluster.vue?vue&type=template&id=b97a24d2", () => {
    api.rerender('b97a24d2', render)
  })

}


export default __exports__